import { GRAPHQL_URL } from '../config.js';

export class GraphQLError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GraphQLError';
  }
}

class GraphQLClient {
  private token: string | null = null;

  setToken(token: string | null): void {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  async query<T = Record<string, unknown>>(
    query: string,
    variables?: Record<string, unknown>,
  ): Promise<T> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    const res = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({ query, variables }),
    });

    if (!res.ok) {
      throw new GraphQLError(`HTTP ${res.status}: ${await res.text()}`);
    }

    const body = await res.json();

    if (body.errors?.length) {
      throw new GraphQLError(body.errors[0].message);
    }

    return body.data as T;
  }
}

export const gql = new GraphQLClient();
